var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFromHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1842 21.4128C23.942 19.3706 29.0599 13.8972 29.0599 10.1607C29.0599 6.83171 26.22 4.13281 22.717 4.13281C20.3643 4.13281 18.3147 5.35366 17.2199 7.16204C16.1251 5.35366 14.0755 4.13281 11.7227 4.13281C8.21979 4.13281 5.37988 6.83171 5.37988 10.1607C5.37988 12.8504 8.03204 16.4406 10.5472 19.0025",
    fill: "#E4C1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.91992 23.2142L4.3278 21.9961L8.34429 28.5077L5.87941 30.0265",
    fill: "#FF8165"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.91992 22.5265L4.60587 21.1855L9.0862 28.3541L6.33667 30.0261",
    stroke: "#081E54",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5694 22.0843L18.9409 22.0811C19.9297 22.0811 20.7312 21.2796 20.7312 20.2903C20.7312 19.3015 19.9297 18.5 18.9409 18.5L12.0914 18.5031C11.2988 18.5031 10.5201 18.7137 9.83596 19.1129L5.50977 21.6367",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5694 22.0843L18.9409 22.0811C19.9297 22.0811 20.7312 21.2796 20.7312 20.2903C20.7312 19.3015 19.9297 18.5 18.9409 18.5L12.0914 18.5031C11.2988 18.5031 10.5201 18.7137 9.83596 19.1129L5.50977 21.6367",
    stroke: "#081E54",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3915 22.0782L27.2231 18.6418C28.1339 18.2641 29.1873 18.7009 29.5645 19.6113C29.9418 20.5222 29.5054 21.576 28.595 21.9532L20.6773 25.7557C20.1249 25.9895 19.5304 26.1105 18.93 26.1105H11.8937C11.4067 26.1105 10.9286 26.2427 10.5115 26.4931L8.91113 27.4541",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3915 22.0782L27.2231 18.6418C28.1339 18.2641 29.1873 18.7009 29.5645 19.6113C29.9418 20.5222 29.5054 21.576 28.595 21.9532L20.6773 25.7557C20.1249 25.9895 19.5304 26.1105 18.93 26.1105H11.8937C11.4067 26.1105 10.9286 26.2427 10.5115 26.4931L8.91113 27.4541",
    stroke: "#081E54",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3536 21.1853C24.2757 18.9084 29.6982 12.8062 29.6982 8.6404C29.6982 4.92891 26.6892 1.91992 22.9777 1.91992C20.4849 1.91992 18.3132 3.28104 17.1533 5.29719C15.9933 3.28104 13.8217 1.91992 11.3289 1.91992C7.61738 1.91992 4.6084 4.92891 4.6084 8.6404C4.6084 11.6391 7.41846 15.6418 10.0833 18.498",
    stroke: "#081E54",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFromHeart);
export default __webpack_public_path__ + "static/media/FromHeart.64e92f7ba24055a9763b4864deec2528.svg";
export { ForwardRef as ReactComponent };